import { useFeedback, useTranslation } from "@opendash/core";
import { ColorPicker } from "@opendash/ui";
import { Button, Form, Input, Switch } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Kanban_State } from "../../../../js/parsegenerated";
import { KanbanStateDeleteModal } from "./KanbanStateDeleteModal";

export const KanbanStateForm = observer(
  (props: {
    monitorstate: Kanban_State;
    inboxdisabled: boolean;
    finisheddisabled: boolean;
    onFinishedColumnChanged: Function;
    onInboxColumnChanged: Function;
    onOkDelete: Function;
  }) => {
    const t = useTranslation();
    const { message } = useFeedback();
    const { TextArea } = Input;
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>();
    const [color, setColor] = useState<string>(props.monitorstate.get("color"));
    const [inboxChecked, setInboxChecked] = useState<boolean>(
      props.monitorstate.get("isInbox")
    );
    const [finishedChecked, setFinishedChecked] = useState<boolean>(
      props.monitorstate.get("isFinished")
    );
    const [deleteModalVisible, setDeleteModalVisible] =
      useState<boolean>(false);

    const onSave = () => {
      setLoading(true);
      form.validateFields().then(
        async (values: any) => {
          //   Save the new values for the monitor state
          props.monitorstate.set("color", values.color);
          props.monitorstate.set("description", values.description);
          props.monitorstate.set("isFinished", values.isFinished);
          props.monitorstate.set("isInbox", values.isInbox);
          props.monitorstate.set("label", values.label);
          props.monitorstate.save().then(
            (savedobject) => {
              message.success(t("maintenance:global.messages.save.success"), 2);
              setLoading(false);
              form.resetFields();
            },
            (error) => {}
          );
        },
        (errors: any): void => {
          console.log(errors);
          message.success(t("maintenance:global.messages.save.error"), 2);
        }
      );
    };

    const onCancelDelete = () => {
      setDeleteModalVisible(false);
    };

    const onOkDelete = () => {
      setDeleteModalVisible(false);
      setLoading(true);
      props.onOkDelete();
      message.success(t("maintenance:global.messages.delete.success"), 2);
    };

    return (
      <>
        <Form layout="vertical" form={form}>
          <Form.Item
            label={t("maintenance:monitor.manage.form.label.label")}
            name="label"
            initialValue={props.monitorstate.get("label")}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t("maintenance:monitor.manage.form.description.label")}
            name="description"
            initialValue={props.monitorstate.get("description")}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item
            label={t("maintenance:monitor.manage.form.isInbox.label")}
            name="isInbox"
            initialValue={props.monitorstate.get("isInbox")}
            valuePropName="checked"
            extra={
              props.inboxdisabled && inboxChecked
                ? t("maintenance:monitor.manage.form.isInbox.disabled")
                : ""
            }
          >
            <Switch
              checkedChildren={t(
                "maintenance:monitor.manage.form.isInbox.checked"
              )}
              unCheckedChildren={t(
                "maintenance:monitor.manage.form.isInbox.unchecked"
              )}
              disabled={inboxChecked ? props.inboxdisabled : false}
              onChange={(checked) => {
                setInboxChecked(checked);
                props.monitorstate.set("isInbox", checked);
                props.onInboxColumnChanged();
              }}
            />
          </Form.Item>
          <Form.Item
            label={t("maintenance:monitor.manage.form.isFinished.label")}
            name="isFinished"
            initialValue={props.monitorstate.get("isFinished")}
            valuePropName="checked"
            extra={
              props.finisheddisabled && finishedChecked
                ? t("maintenance:monitor.manage.form.isFinished.disabled")
                : ""
            }
          >
            <Switch
              checkedChildren={t(
                "maintenance:monitor.manage.form.isFinished.checked"
              )}
              unCheckedChildren={t(
                "maintenance:monitor.manage.form.isFinished.unchecked"
              )}
              disabled={finishedChecked ? props.finisheddisabled : false}
              onChange={(checked) => {
                setFinishedChecked(checked);
                props.monitorstate.set("isFinished", checked);
                props.onFinishedColumnChanged();
              }}
            />
          </Form.Item>
          <Form.Item
            label={t("maintenance:monitor.manage.form.color.label")}
            name="color"
            initialValue={props.monitorstate.get("color")}
          >
            <ColorPicker
              value={color}
              onChange={(value) => {
                setColor(value);
              }}
            />
          </Form.Item>
          <Button type="primary" onClick={onSave} loading={loading}>
            {t("maintenance:global.button.save_label")}
          </Button>
          <Button
            danger
            onClick={() => {
              setDeleteModalVisible(true);
            }}
            loading={loading}
            style={{ marginLeft: 10 }}
          >
            {t("maintenance:global.button.delete_label")}
          </Button>
        </Form>

        <KanbanStateDeleteModal
          monitorstate={props.monitorstate}
          onOk={onOkDelete}
          onCancel={onCancelDelete}
          open={deleteModalVisible}
        />
      </>
    );
  }
);
